<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="工作计划" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="content">
              <j-input-pop v-model="model.content" placeholder="请输入工作计划" :width="600" :height="400"></j-input-pop>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="权重" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="weight">
              <a-input-number v-model="model.weight" placeholder="请输入权重" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="虚线汇报对象" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="facilitators">
              <j-select-user-by-dep v-model="model.facilitators" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import Vue from 'vue'
import { USER_NAME } from '@/store/mutation-types'

export default {
  name: 'OkrPlanModal',
  components: {},
  props: {
    mainId: {
      type: String,
      required: false,
      default: '',
    },
    mainRow: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      confirmLoading: false,
      validatorRules: {
        assignner: [{ required: true, message: '请输入用户!' }],
        content: [{ required: true, message: '请输入工作计划!' }],
        weight: [{ required: true, message: '请输入权重!' }],
      },
      url: {
        add: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/addOkrPlanRevise`,
        edit: `${window._CONFIG['doBaseUrl']}/doMistServer/okrSummary/editOkrPlanRevise`,
      },
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    add() {
      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          if (!this.model['okrSummaryId']) {
            this.model['okrSummaryId'] = this.mainId
          }
          this.model['reporter'] = that.mainRow.reporter
          this.model['assignner'] = Vue.ls.get(USER_NAME)
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
